<template>
   <div class="small-card" :class="[{ full: full }, card?.type]">
      <div class="card-content">
         <!-- meta -->
         <div class="meta label grey">{{ card?.type ?? label }}</div>
         <div class="flags">
            <!-- Remove Card -->
            <Tag
               role="button"
               class="basic grey action"
               v-on:click.prevent="remove"
               v-if="saveable"
               >Remove</Tag
            >
            <IconLight />
         </div>
         <!-- Core Text -->
         <h4 class="bold">{{ title }}</h4>
         <div class="text">
            <div class="small mb-1" v-if="text" v-html="text"></div>
            <Btn
               v-if="btnText"
               v-bind="{
                  text: btnText,
                  url: btnLink,
                  textLink: true,
                  classes: 'red',
                  icon: 'caret',
               }"
            />
         </div>

         <div class="move" v-if="movable">
            <IconMove />
         </div>
      </div>
   </div>
</template>

<script setup lang="ts">
import IconLight from "~/assets/images/icons/lightbulb.svg?component";
import IconMove from "~/assets/images/icons/move.svg?component";

const { removeClassNote } = useClassesStore();
const props = defineProps({
   card: {
      type: Object,
      required: true,
   },
   label: {
      type: String,
      required: false,
   },
   movable: {
      type: Boolean,
      default: false,
   },
   saveable: {
      type: Boolean,
      default: false,
   },
   full: {
      type: Boolean,
      default: false,
   },
});
const card = toRef(props, "card");
const title = computed(() => props.card?.description ?? props.card.card_title);
const text = computed(() => props.card?.learning_goal);
// const icon = computed(() => props.card?.card_icon);
const btnLink = computed(() => props.card?.card_link_url);
const btnText = computed(() => props.card?.card_link_text);
const remove = async () => {
   await removeClassNote(card.value.id);
};
</script>

<style lang="scss">
@import "~/assets/scss/globals/small-card";
</style>
